export function broadcastScrollHeight(height) {
  if (process.env.VUE_APP_TARGET !== 'jxt') {
    return
  }
  if (!height) {
    height = document.body.scrollHeight
  }
  parent && parent.postMessage({
    action: 'broadcastScrollHeight',
    payload: height + 40
  }, '*')
}
